// import { ReactAuthWrapper, logout } from "@carrier/reactauthwrapper";
import { ReactAuthWrapper } from "@carrier-sce-sharedpackages/reactauthwrapper";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import axios from "axios";
import React,{useState} from "react";
import ReactDOM from "react-dom";
import App from "./App";
import useStyles from "./Style";
import getUsernameFromToken from "./User";
import appConfig from "./config";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
const settings = ["Logout"];
const icons = [<ExitToAppIcon />];
function Root() {
  const classes = useStyles();

  const [appAccess, setAppAccess] = useState(false);
  const callback = (permissions) => {
    console.log("permissions->", permissions);
    if (permissions.appAccess) {
      console.log("permissions->", permissions.appAccess);
      setAppAccess(true);
    }
  };
  const username = getUsernameFromToken();
  

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchAPI = axios.create({
    //  //baseURL: "http://localhost:5000/api",
    // baseURL: "https://mbd-automl-api-development.us-east-1.elasticbeanstalk.com/api",
    // baseURL: "https://mbd-automl-api-dev.carrier.com/api/",
    // baseURL: "https://eoejdxdm3b.execute-api.us-east-1.amazonaws.com/dev/api/"
    baseURL:"https://87p2qcipf0.execute-api.us-east-1.amazonaws.com/prod/api"
  });
  return (
    <ReactAuthWrapper appConfig={appConfig.api} getPermissions={callback}>

      <App username={username} classes={classes} fetchAPI={fetchAPI} />
    </ReactAuthWrapper>
  );
}

ReactDOM.render(<Root />, document.getElementById("root"));
serviceWorker.unregister();
